module.exports = __webpack_public_path__ + "static/img/most-active-leads_empty.3c6462c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/most-active-leads_empty.svg
// module id = 1446
// module chunks = 0